export function DiamondLogo({ className, ...rest }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      width="1em"
      {...rest}
    >
      <path
        d="M18.6454 3.95371V3.95371C18.384 3.60514 17.9737 3.39999 17.538 3.39999H6.46363H6.46363C6.02792 3.39999 5.61763 3.60514 5.3562 3.95371L2.27661 8.06136V8.06136C1.89186 8.57468 1.9102 9.2851 2.32091 9.77789L10.9386 20.2062V20.2062C11.4294 20.7923 12.3025 20.8696 12.8887 20.3787C12.9511 20.3264 13.0089 20.2687 13.0612 20.2062L21.6788 9.77789V9.77789C22.0896 9.28509 22.1079 8.57469 21.7231 8.06136L18.6454 3.95371Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path d="M8.4998 11.9L11.9998 20.4" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
      <path d="M15.5005 11.9L12.0044 20.7081" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
      <path d="M2 8.93246H21.9984" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
      <path
        d="M7.84863 8.93716L12.0015 3.39999L16.1544 8.93716"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
}
